import { createRouter, createWebHashHistory } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import HomePage from '@/pages/HomePage.vue';
import ProductDetail from '@/pages/ProductDetail.vue';
// @TODO Default URL - domain + company name?
const routes = [
  {
    path: '/',
    component: DefaultLayout, // Use the layouts as the wrapper
    children: [
      {
        path: '', // Default child route
        name: 'Home',
        component: HomePage,
      },
      {
        path: '/:company/:id', // Dynamic route for ProductDetail
        name: 'ProductDetail',
        component: ProductDetail,
        props: true, // Pass route params as props to the component
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
